import * as React from 'react';
export const IcFlashOff = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M18.05 12.71a2 2 0 00-1.51-3.24h-2.67l2-5.48a1.48 1.48 0 00-2.54-1.43l-2.88 3.6 7.14 7.14.46-.59zM20.49 19L5 3.51A1.054 1.054 0 003.51 5l4.37 4.32-2.29 2.86a2 2 0 001.54 3.2h2.8L8.16 20a1.48 1.48 0 002.52 1.48L15 16.39l4 4.1A1.054 1.054 0 1020.49 19z'
      fill='currentColor'
    />
  </svg>
);
